import React from 'react';
import { Wrapper } from './CaracteristicasImovel-styled';

const CaracteristicasImovel = ({
    detalhesImovel,
    detalhesCondominio,
    detalhesSeguranca,
    detalhesLazer,
}) => {
    return (
        <Wrapper>
            {Boolean(detalhesImovel?.length) && (
                <ul>
                    {detalhesImovel?.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            )}
            {Boolean(detalhesCondominio?.length > 0) && (
                <h3>Detalhes do condomínio</h3>
            )}
            {Boolean(detalhesCondominio?.length) && (
                <ul>
                    {detalhesCondominio?.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            )}
            {Boolean(detalhesSeguranca?.length > 0) && (
                <h3>Detalhes de segurança</h3>
            )}
            {Boolean(detalhesSeguranca?.length) && (
                <ul>
                    {detalhesSeguranca?.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            )}
            {Boolean(detalhesLazer?.length > 0) && <h3>Detalhes de lazer</h3>}
            {Boolean(detalhesLazer?.length) && (
                <ul>
                    {detalhesLazer?.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            )}
        </Wrapper>
    );
};

export default CaracteristicasImovel;
